import React, {useEffect, useRef} from 'react';
import { Point } from "../../../types/index";

interface Props {
    scale: number,
    anchor: Point
}

const ZoomMapComponent: React.FC<Props> = ({scale, anchor}) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const elem = ref.current;
        if (elem) {
           elem.style.width = 1 / scale * 100 + '%';
           elem.style.height = 1 / scale * 100 + '%';
           elem.style.left = anchor.x * (scale - 1) / scale * 100 + '%';
           elem.style.top = anchor.y * (scale - 1) / scale * 100 + '%';
        }
    });

    
    return (
        <div>
            <div className='zoom-map'>
                <div className='pos-rel h-100 w-100'>
                    <div className='zoom-map-indicator'
                         ref={ref}
                    />

                </div>
            </div>
            <div className='zoom-title'>
                x{ scale.toFixed(2) }
            </div>
        </div>

    )

};

export default ZoomMapComponent